import { assertNever } from '@eversports/klimt-utilities/assert-never'

import type { BaseNotification } from '../Notifications.types'

const getNotificationLink = (notification: BaseNotification): { to: string; isExternal: boolean } | null => {
  if (!notification.link) return null
  switch (notification.link.__typename) {
    case 'NotificationLinkEvent':
      return {
        to: `/activity/${notification.link.event.id}`,
        isExternal: false,
      }
    case 'NotificationLinkEventSession':
      return {
        to: `/activity/${notification.link.bookableItem.id}`,
        isExternal: false,
      }
    case 'NotificationLinkMatch':
      return { to: `/match/${notification.link.match.id}`, isExternal: false }
    case 'NotificationLinkUrl':
      return { to: notification.link.url, isExternal: true }
    case 'NotificationLinkUser':
      return { to: `/user/${notification.link.user.handle}`, isExternal: false }
    case 'NotificationLinkVenue':
      return { to: `/s/${notification.link.venue.slug}`, isExternal: false }
    default:
      return assertNever(notification.link)
  }
}

export default getNotificationLink
